module.exports = __webpack_public_path__ + "static/media/miles.4cfd8497.svg";